import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesCurrentModel } from './types';
import { foreignActivitiesCurrentItemValidator } from './validators/item';

const foreignActivitiesCurrentValidator: ValidateJSModel<ForeignActivitiesCurrentModel> = {
  HasCurrentActivity: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasCurrentActivity?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignActivitiesCurrentItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesCurrentValidator;
